import React, {useContext} from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import Header from './header';
import CompanyCard from './company-card';
import {PAGE_WIDTH} from '../../../../shared/style/dimensions';
import {RouteContext} from '../../../../shared/enhancers/router-enhancer';
import {PAGE_BACKGROUND} from '../../../../shared/style/colors';
import {withAnalyticsPayload} from '../../../../shared/enhancers/analytics-enhancer';
import {PrivateModeContext} from './../../../../shared/enhancers/private-mode-enchancer';

const Container = glamorous.div({
  margin: '25px auto',
  maxWidth: PAGE_WIDTH
});

const Page = glamorous.div({
  background: PAGE_BACKGROUND,
  padding: '0 0 50px 0'
});

const CompaniesIndex = ({currentUser}) => {
  const privateMode = useContext(PrivateModeContext);
  const {signin} = useContext(RouteContext);
  return (
    <Page>
      <Header />
      <Container>
        <CompanyCard signin={signin} currentUser={currentUser} privateMode={privateMode} />
      </Container>
    </Page>
  );
};

CompaniesIndex.propTypes = {
  currentUser: PropTypes.object
};

export default withAnalyticsPayload({
  'page.name': 'Company Index',
  path: typeof window !== 'undefined' ? window.location.pathname : null,
  url: typeof window !== 'undefined' ? window.location.href : null,
  referrer: typeof document !== 'undefined' ? document.referrer : null
})(CompaniesIndex);
